// extracted by mini-css-extract-plugin
export default {"plan-group-card":"PlanGroupCard_plan-group-card__IlqY0","link":"PlanGroupCard_link__NHBow","background":"PlanGroupCard_background__OEiXz","content":"PlanGroupCard_content__Y7B1Z"};